import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/styles";
import {
  Card,
  CardContent,
  Grid,
  Autocomplete,
  TextField,
  Checkbox,
  FormControlLabel,
  createFilterOptions,
  FormControl,
} from "@mui/material";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles((theme) => ({
  root: {
    height: "100%",
  },
  label: {
    display: "flex",
    justifyContent: "right",
    transformOrigin: "center",
  },
}));
function AssessmentAuditorDetail(props) {
  const { data, autoCompleteData, isViewMode, onComplete } = props;
  const classes = useStyles();
  const { t } = useTranslation();

  useEffect(() => {
    if (!data.siteVisitDate) {
      data.siteVisitDate = new Date();
    }
  }, [data]);

  const handleAutocompleteChange = (event, value) => {
    data.ownerCompESGFrom = value;
    onComplete(Object.assign({}, data));
  };

  const handle3RDCheckboxChange = (event) => {
    data.is3RDChecked = !!event.target.checked;
    onComplete(Object.assign({}, data));
  };
  const handle3RDTextChange = (event) => {
    data.siteVisitBy3RD = event.target.value;
    onComplete(Object.assign({}, data));
  };

  const handleOwnerCompCheckboxChange = (event) => {
    data.isOwnerCompChecked = !!event.target.checked;
    onComplete(Object.assign({}, data));
  };
  const handleOwnerCompTextChange = (event) => {
    data.siteVisitByOwnerComp = event.target.value;
    onComplete(Object.assign({}, data));
  };

  const handleSiteVisitDateChange = (event) => {
    data.siteVisitDate = event;
    onComplete(Object.assign({}, data));
  };

  return (
    <Card variant="outlined" className={classes.root}>
      <CardContent>
        <b>{t("vendorSite.AssessorInfo")}</b>
        <Grid container spacing={2}>
          <Grid item xs={4} sm={4} md={4} lg={4} className={classes.label}>
            {t("vendorSite.AssessorDate")}
          </Grid>
          <Grid item xs={8} sm={8} md={8} lg={8}>
            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <FormControl sx={{ width: "100%" }}>
                <DesktopDatePicker
                  disabled={isViewMode}
                  views={["year", "month", "day"]}
                  label={t("vendorSite.AssessorDate")}
                  inputFormat="dd/MM/yyyy"
                  value={data.siteVisitDate}
                  onChange={handleSiteVisitDateChange}
                  renderInput={(params) => (
                    <TextField size="small" {...params} />
                  )}
                />
              </FormControl>
            </LocalizationProvider>
          </Grid>
          <Grid item xs={4} sm={4} md={4} lg={4} className={classes.label}>
          {t("vendorSite.AssessorOwner")}
          </Grid>
          <Grid item xs={8} sm={8} md={8} lg={8}>
            <Autocomplete
              size="small"
              disabled={isViewMode}
              options={autoCompleteData}
              disablePortal
              getOptionLabel={(option) => option.companyName || ""}
              isOptionEqualToValue={(option, value) =>
                option.companyID === value.companyID
              }
              filterOptions={createFilterOptions({
                limit: 20,
              })}
              value={data.ownerCompESGFrom || {}}
              renderInput={(params) => <TextField size="small" {...params} />}
              onChange={handleAutocompleteChange}
            />
          </Grid>
          <Grid item xs={4} sm={4} md={4} lg={4} className={classes.label}>
          {t("vendorSite.recorder")}
          </Grid>
          <Grid item xs={8} sm={8} md={8} lg={8}>
            <FormControlLabel
              control={
                <Checkbox
                  disabled={isViewMode}
                  checked={!!data.is3RDChecked}
                  onChange={handle3RDCheckboxChange}
                />
              }
              label="Third party"
            />
            <br />
            <TextField
              size="small"
              disabled={!data.is3RDChecked || isViewMode}
              multiline
              rows={2}
              sx={{ width: "100%" }}
              value={data.siteVisitBy3RD || ""}
              onChange={handle3RDTextChange}
            />
            <FormControlLabel
              control={
                <Checkbox
                  disabled={isViewMode}
                  checked={!!data.isOwnerCompChecked}
                  onChange={handleOwnerCompCheckboxChange}
                />
              }
              label={t("vendorSite.assessor")}
            />
            <br />
            <TextField
              size="small"
              disabled={!data.isOwnerCompChecked || isViewMode}
              multiline
              rows={2}
              sx={{ width: "100%" }}
              value={data.siteVisitByOwnerComp || ""}
              onChange={handleOwnerCompTextChange}
            />
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
}

AssessmentAuditorDetail.propTypes = {
  className: PropTypes.string,
  data: PropTypes.object,
  autoCompleteData: PropTypes.array,
  isViewMode: PropTypes.bool,
};

export default AssessmentAuditorDetail;
